/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is BMI accurate for everyone?`)
};

const es_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es el IMC preciso para todos?`)
};

const de_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist BMI für alle genau?`)
};

const nl_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is BMI nauwkeurig voor iedereen?`)
};

const fr_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IMC est-il précis pour tout le monde ?`)
};

const it_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il BMI è accurato per tutti?`)
};

const pt_br2_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMI é preciso para todos?`)
};

const pt_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O IMC é preciso para toda a gente?`)
};

const ja_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMIは全員に正確ですか？`)
};

const zh_bmi_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMI 对所有人都准确吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_faq3_q", locale)
	if (locale === "en") return en_bmi_hub_faq3_q(inputs)
	if (locale === "es") return es_bmi_hub_faq3_q(inputs)
	if (locale === "de") return de_bmi_hub_faq3_q(inputs)
	if (locale === "nl") return nl_bmi_hub_faq3_q(inputs)
	if (locale === "fr") return fr_bmi_hub_faq3_q(inputs)
	if (locale === "it") return it_bmi_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_faq3_q(inputs)
	if (locale === "pt") return pt_bmi_hub_faq3_q(inputs)
	if (locale === "ja") return ja_bmi_hub_faq3_q(inputs)
	return zh_bmi_hub_faq3_q(inputs)
};